import React from "react";

export default function Info() {
  return (
    <div className="about__info grid">
      <div className="about__box">
        <i className="bx bx-award about__icon"></i>
        <h3 className="about__title">Experience</h3>
        <span className="about__subtitle">4.7 years Working</span>
      </div>
      <div className="about__box">
        <i className="bx bx-briefcase-alt about__icon"></i>
        <h3 className="about__title">Completed</h3>
        <span className="about__subtitle">15 Projects</span>
      </div>
      <div className="about__box">
        <i className="bx bx-certification about__icon"></i>
        <h3 className="about__title">Credentials</h3>
        <span className="about__subtitle">4 Certifications</span>
      </div>
    </div>
  );
}
